var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"woo-video-overlays"},[_c('div',{staticClass:"woo-video-text-overlays"},_vm._l((_vm.textOverlays),function(overlay){return _c('div',{key:overlay.id,staticClass:"woo-video-overlay",class:{
        large: overlay.isLarge,
        small: overlay.isSmall,
        bordered: overlay.isBordered
      },style:({
        'text-align': overlay.text_alignment || 'center',
      }),domProps:{"innerHTML":_vm._s(overlay.text)}})}),0),_c('div',{staticClass:"woo-video-link-overlays"},_vm._l((_vm.linkOverlays),function(overlay){return _c('a',{key:overlay.id,attrs:{"target":"_blank","href":overlay.url}},[_c('div',{staticClass:"woo-video-overlay animate__animated animate__fadeInUp animate__faster",class:{
          large: overlay.isLarge,
          small: overlay.isSmall
        },style:({
          'text-align': overlay.text_alignment || 'center',
        })},[_c('v-icon',{staticClass:"woo-link-icon"},[_vm._v("mdi-link")]),_vm._v(" "+_vm._s(overlay.text)+" ")],1)])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }